import { Type } from '@angular/core';
import { SidebarType } from '../models/enums/sidebar-type.enum';

export interface SidebarComponentConfig {
  component: () => Promise<Type<any>>;
  componentType: SidebarType;
}

export const SidebarComponentsConfiguration: SidebarComponentConfig[] = [
  {
    component: () =>
      import(
        '../../super-admin/company-users/feature-company-employees/company-employees-add/company-employee-add.component'
      ).then((it) => it.CompanyEmployeeAddComponent),
    componentType: SidebarType.CompanyEmployeeAdd,
  },
  {
    component: () =>
      import(
        '../../super-admin/company-users/feature-company-employees/company-employees-edit/company-employee-edit.component'
      ).then((it) => it.CompanyEmployeeEditComponent),
    componentType: SidebarType.CompanyEmployeeEdit,
  },

  {
    component: () =>
      import(
        '../../super-admin/company-courses/feature-company-courses/company-course-add/company-course-add.component'
      ).then((it) => it.CompanyCourseAddComponent),
    componentType: SidebarType.CompanyCourseAdd,
  },
  {
    component: () =>
      import(
        '../../super-admin/company-courses/feature-company-courses/company-course-edit/company-course-edit.component'
      ).then((it) => it.CompanyCourseEditComponent),
    componentType: SidebarType.CompanyCourseEdit,
  },

  {
    component: () =>
      import(
        '../../super-admin/company/feature-companies/companies-add/company-add.component'
      ).then((it) => it.CompanyAddComponent),
    componentType: SidebarType.CompanyAdd,
  },
  {
    component: () =>
      import(
        '../../super-admin/company/feature-companies/companies-edit/company-edit.component'
      ).then((it) => it.CompanyEditComponent),
    componentType: SidebarType.CompanyEdit,
  },
  {
    component: () =>
      import(
        '../../users/feature-admin-users/users-add/users-add.component'
      ).then((it) => it.UsersAddComponent),
    componentType: SidebarType.UserAdd,
  },
  {
    component: () =>
      import(
        '../../menu/feature-menu-builder/category-add/category-add.component'
      ).then((it) => it.CategoryAddComponent),
    componentType: SidebarType.CategoryAdd,
  },
  {
    component: () =>
      import(
        '../../menu/feature-menu-builder/category-edit/category-edit.component'
      ).then((it) => it.CategoryEditComponent),
    componentType: SidebarType.CategoryEdit,
  },
  {
    component: () =>
      import(
        '../../menu/feature-menu-builder/category-group-add/category-group-add.component'
      ).then((it) => it.CategoryGroupAddComponent),
    componentType: SidebarType.CategoryGroupAdd,
  },
  {
    component: () =>
      import(
        '../../menu/feature-menu-builder/category-group-edit/category-group-edit.component'
      ).then((it) => it.CategoryGroupEditComponent),
    componentType: SidebarType.CategoryGroupEdit,
  },
  {
    component: () =>
      import(
        '../../menu/feature-menu-tags/tag-group-add/tag-group-add.component'
      ).then((it) => it.TagGroupAddComponent),
    componentType: SidebarType.TagGroupAdd,
  },
  {
    component: () =>
      import(
        '../../menu/feature-menu-tags/tag-group-edit/tag-group-edit.component'
      ).then((it) => it.TagGroupEditComponent),
    componentType: SidebarType.TagGroupEdit,
  },
  {
    component: () =>
      import(
        '../../menu/feature-menu-tags/tag-add/tag-add.component'
      ).then((it) => it.TagAddComponent),
    componentType: SidebarType.TagAdd,
  },
  {
    component: () =>
      import(
        '../../menu/feature-menu-tags/tag-edit/tag-edit.component'
      ).then((it) => it.TagEditComponent),
    componentType: SidebarType.TagEdit,
  },
  {
    component: () =>
      import(
        '../../menu/feature-menu-builder/menuitem-add/menuitem-add.component'
      ).then((it) => it.MenuitemAddComponent),
    componentType: SidebarType.MenuItemAdd,
  },
  {
    component: () =>
      import(
        '../../menu/feature-menu-builder/menuitem-edit/menuitem-edit.component'
      ).then((it) => it.MenuitemEditComponent),
    componentType: SidebarType.MenuItemEdit,
  },
  {
    component: () =>
      import(
        '../../super-admin/global-menu/feature-sku-menu-builder/sku-menuitem-add/sku-menuitem-add.component'
      ).then((it) => it.GlobalMenuitemAddComponent),
    componentType: SidebarType.MenuSkuItemAdd,
  },
  {
    component: () =>
      import(
        '../../super-admin/global-menu/feature-sku-menu-builder/sku-menuitem-edit/sku-menuitem-edit.component'
      ).then((it) => it.GlobalMenuitemEditComponent),
    componentType: SidebarType.MenuSkuItemEdit,
  },
  {
  component: () =>
      import(
        '../../menu/feature-menu-modifiers/modifier-group-add/modifier-group-add.component'
      ).then((it) => it.ModifierGroupAddComponent),
    componentType: SidebarType.ModifierGroupAdd,
  },
  {
    component: () =>
      import(
        '../../menu/feature-menu-modifiers/modifier-group-edit/modifier-group-edit.component'
      ).then((it) => it.ModifierGroupEditComponent),
    componentType: SidebarType.ModifierGroupEdit,
  },
  {
  component: () =>
      import(
        '../../menu/feature-menu-modifiers/modifier-add/modifier-add.component'
      ).then((it) => it.ModifierAddComponent),
    componentType: SidebarType.ModifierAdd,
  },
  {
    component: () =>
      import(
        '../../menu/feature-menu-modifiers/modifier-edit/modifier-edit.component'
      ).then((it) => it.ModifierEditComponent),
    componentType: SidebarType.ModiferEdit,
  },

    {
  component: () =>
      import(
        '../../discount-specials/feature-discount-and-specials/special-add/special-add.component'
      ).then((it) => it.SpecialAddComponent),
    componentType: SidebarType.SpecialAdd,
  },
  {
    component: () =>
      import(
        '../../discount-specials/feature-discount-and-specials/special-edit/special-edit.component'
      ).then((it) => it.SpecialEditComponent),
    componentType: SidebarType.SpecialEdit,
  },
  {
  component: () =>
      import(
        '../../discount-specials/feature-discount-and-specials/discount-add/discount-add.component'
      ).then((it) => it.DiscountAddComponent),
    componentType: SidebarType.DiscountAdd,
  },
  {
    component: () =>
      import(
        '../../discount-specials/feature-discount-and-specials/discount-edit/discount-edit.component'
      ).then((it) => it.DiscountEditComponent),
    componentType: SidebarType.DiscountEdit,
  },
  {
    component: () =>
      import(
        '../../menu/feature-menu-builder/menuitem-import/menuitem-import.component'
      ).then((it) => it.MenuitemImportComponent),
    componentType: SidebarType.MenuItemSkuImport,
  },

];
